/**
 * SPDX-FileCopyrightText: 2020 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

import './viewer.js'
import Vue from 'vue'
import Office from './view/Office.vue'
import types from './helpers/types.js'
import axios from '@nextcloud/axios'
import { getCapabilities } from '@nextcloud/capabilities'

import './css/icons.css'

// eslint-disable-next-line
__webpack_nonce__ = btoa(window.OC.requestToken)

// eslint-disable-next-line
__webpack_public_path__ = window.OC.linkTo('officeonline', 'js/')

Vue.prototype.t = window.t
Vue.prototype.n = window.n
Vue.prototype.OC = window.OC
Vue.prototype.OCA = window.OCA

const NewFilePlugin = {
	attach(newFileMenu) {
		const self = this
		const document = types.getFileType('document')
		const spreadsheet = types.getFileType('spreadsheet')
		const presentation = types.getFileType('presentation')

		newFileMenu.addMenuEntry({
			id: 'add-' + document.extension,
			displayName: t('officeonline', 'New Document'),
			templateName: t('officeonline', 'New Document') + '.' + document.extension,
			iconClass: 'icon-filetype-document',
			fileType: 'x-office-document',
			actionHandler(filename) {
				self._createDocument(document.mime, filename)
			},
		})

		newFileMenu.addMenuEntry({
			id: 'add-' + spreadsheet.extension,
			displayName: t('officeonline', 'New Spreadsheet'),
			templateName: t('officeonline', 'New Spreadsheet') + '.' + spreadsheet.extension,
			iconClass: 'icon-filetype-spreadsheet',
			fileType: 'x-office-spreadsheet',
			actionHandler(filename) {
				self._createDocument(spreadsheet.mime, filename)
			},
		})

		newFileMenu.addMenuEntry({
			id: 'add-' + presentation.extension,
			displayName: t('officeonline', 'New Presentation'),
			templateName: t('officeonline', 'New Presentation') + '.' + presentation.extension,
			iconClass: 'icon-filetype-presentation',
			fileType: 'x-office-presentation',
			actionHandler(filename) {
				self._createDocument(presentation.mime, filename)
			},
		})
	},

	_createDocument(mimetype, filename) {
		const dir = document.getElementById('dir') ? document.getElementById('dir').value : window.FileList.getCurrentDirectory()
		try {
			OCA.Files.Files.isFileNameValid(filename)
		} catch (e) {
			window.OC.dialogs.alert(e, t('core', 'Could not create file'))
			return
		}
		filename = FileList.getUniqueName(filename)
		const path = dir + '/' + filename

		const isPublic = document.getElementById('isPublic') ? document.getElementById('isPublic').value === '1' : false
		if (isPublic) {
			return window.FileList.createFile(filename).then(function() {
				OCA.Viewer.open({ path })
			})
		}

		axios.post(OC.generateUrl('apps/officeonline/ajax/documents/create'), { mimetype, filename, dir }).then(({ data }) => {
			console.debug(data)
			if (data && data.status === 'success') {
				window.FileList.add(data.data, { animate: true, scrollTo: true })
				window.OCA.Viewer.open({ path })
			} else {
				window.OC.dialogs.alert(data.data.message, t('core', 'Could not create file'))
			}
		})
	},
}

document.addEventListener('DOMContentLoaded', () => {
	// PUBLIC SHARE LINK HANDLING
	const isPublic = document.getElementById('isPublic') ? document.getElementById('isPublic').value === '1' : false
	const mimetype = document.getElementById('mimetype') ? document.getElementById('mimetype').value : undefined
	const isSupportedMime = isPublic
		&& getCapabilities().officeonline.mimetypes.indexOf(mimetype) !== -1
		&& getCapabilities().officeonline.mimetypesNoDefaultOpen.indexOf(mimetype) === -1
	if (isSupportedMime) {
		/* eslint-disable-next-line no-new */
		new Vue({
			render: h => h(Office, { props: { fileName: document.getElementById('filename').value } }),
		}).$mount('#imgframe')
	}

	OC.Plugins.register('OCA.Files.NewFileMenu', NewFilePlugin)
})
